import React, { FC, useCallback, useMemo, useState } from 'react';

import { useUpdateEffect } from '@chakra-ui/react';

import { useSKU } from 'hooks/useSKU';

import { useQuery } from 'react-query';
import { fetchPendingDeliveries } from 'api/order';

import { washHub } from 'store/slices';

import { DataTable } from 'components/modules/DataTable';

import { buildDeliveriesColumns } from './deliveriesColumns';

export const DeliveriesTab: FC = () => {
  const [page, setPage] = useState<number>(1);

  const skuData = useSKU('item');

  const washHubId = washHub.selectors.useSelectedWashHubId();
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();
  const queryKey = `${washHubId}-pending-deliveries`;

  const queryFn = () =>
    fetchPendingDeliveries({
      page,
      limit: 10,
      washHub: washHubId,
    });

  const options = {
    enabled: isWashHubIdValid,
    keepPreviousData: true,
  };

  const { data, refetch, isFetching, isLoading } = useQuery(
    queryKey,
    queryFn,
    options,
  );

  useUpdateEffect(() => {
    refetch();
  }, [page]);

  const items = data?.items || [];
  const totalCount = data?.total || 0;
  const totalPages = data?.totalPages || 0;

  const pagination = {
    page,
    setPage,
    totalCount,
    totalPages,
  };
  interface skuIndex {
    [key: string]: number | undefined;
  }
  const getSkuItemsById = useCallback(() => {
    const skuIndex: skuIndex = {};

    skuData.data?.map((sku) => {
      return (skuIndex[sku._id] = sku.itemsInCase);
    });

    return skuIndex;
  }, [skuData]);
  const skuItems = skuData.data || [];

  const skuItemsById = getSkuItemsById();

  const getSkuNameById = (skuID?: string) => {
    let skuNamebyId = '';

    if (!Boolean(skuID)) return (skuNamebyId = ' - ');

    const skuName = skuItems.find((_sku) => _sku._id === skuID);
    skuNamebyId = skuName?.name || ' - ';
    return skuNamebyId;
  };

  const columns = useMemo(
    () => buildDeliveriesColumns(getSkuNameById, skuItemsById),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [skuItems, skuItemsById],
  );

  return (
    <DataTable
      minW="710px"
      mt={6}
      data={items}
      columns={columns}
      isLoading={isLoading || isFetching}
      pagination={pagination}
    />
  );
};
